import { Message } from "@mail/core/common/message";
import { SubChannelPreview } from "@mail/discuss/core/public_web/sub_channel_preview";

Object.assign(Message.components, { SubChannelPreview });
